import React from 'react';
import Slider from "react-slick";

import { carouselDefaultConfig } from './baseCarousel.constants';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./baseCarousel.scss";

const BaseCarousel = React.forwardRef((props, ref) => {

    const {children, carouselContainerClass, ...configurationProps} = props;

    return (
        <div className={`b2b-lib-carouselContainer ${carouselContainerClass}`}>
            <Slider ref={ref} {...configurationProps}>
                {children}
            </Slider>
        </div>
    )
});

BaseCarousel.defaultProps = {
    ...carouselDefaultConfig,
    carouselContainerClass: ""
}

export default BaseCarousel
